export default "__VITE_ASSET__25fc4154__"